{
  "accountInformation": "账户信息",
  "accountStatus": "账户状态",
  "active": "已激活",
  "admin": "管理员",
  "adminBadge": "管理员",
  "adminPrivileges": "管理员权限",
  "aiDefaultHelp": "今天我能为您提供什么帮助？",
  "aiDepositHelp": "咨询充值问题、延迟或确认情况。",
  "aiKycHelp": "咨询 KYC 验证及所需文件。",
  "aiLoginHelp": "咨询登录、密码或账户访问问题。",
  "aiP2pHelp": "咨询 P2P 订单、争议或付款问题。",
  "aiSupportAssistant": "AI 客服助手",
  "aiSupportAssistantText": "获取常见问题的即时解答，或向我们的团队提交工单。",
  "aiWithdrawHelp": "咨询提现状态、延迟或要求。",
  "askAiSupport": "咨询 AI 客服",
  "bio": "专业简介",
  "capital": "本金",
  "changeImage": "更换头像",
  "cnicBack": "身份证（背面）",
  "cnicFront": "身份证（正面）",
  "connectedWallet": "已连接钱包",
  "country": "国家",
  "createSupportTicket": "创建支持工单",
  "describeIssue": "描述您的问题",
  "disabled": "已禁用",
  "displayName": "显示名称",
  "editProfile": "编辑资料",
  "email": "邮箱",
  "emailOtpSendFailed": "验证码发送失败，请重试。",
  "emailOtpSent": "验证码已发送至您的邮箱。",
  "emailVerification": "邮箱验证",
  "emailVerifiedSuccessfully": "邮箱验证成功。",
  "enabled": "已启用",
  "enterEmailOtp": "输入验证码",
  "enterOtpFirst": "请先输入验证码。",
  "estimatedProfit": "预估收益",
  "faceVerificationNotAutomated": "自动人脸验证暂不可用。您上传的自拍照将作为 KYC 审核的一部分进行人工审核。",
  "failedLoadNotifications": "通知加载失败。",
  "failedMarkAllRead": "全部标记为已读失败。",
  "failedMarkRead": "标记为已读失败。",
  "failedSubmitTicket": "工单提交失败。",
  "fullLegalName": "法定全名",
  "fullName": "全名",
  "idNumber": "证件号码",
  "imagePreview": "图片预览",
  "imageTooLarge": "图片大小最大为 5 MB。",
  "inactive": "未激活",
  "invalidImageType": "仅支持 JPG、PNG 及 WEBP 格式图片。",
  "invalidOtp": "验证码无效或已过期，请重试。",
  "joinedDate": "注册日期",
  "kycStatus": "KYC 状态",
  "kycSubmissionFailed": "KYC 提交失败。",
  "kycSubmittedSuccessfully": "KYC 提交成功。",
  "lastLogin": "最后登录",
  "liquidationZone": "强平区间",
  "loadingNotifications": "通知加载中...",
  "loadingProfile": "个人资料加载中...",
  "markAllRead": "全部标记为已读",
  "mobileNumberCountryCode": "手机号码（含国家代码）",
  "network": "网络",
  "noNotifications": "暂无通知。",
  "noUtilityToolsFound": "未找到实用工具。",
  "notSubmitted": "未提交",
  "notVerifiedEmail": "未验证",
  "openTool": "打开工具",
  "owner": "所有者",
  "ownerBadge": "所有者",
  "ownerControlCenter": "所有者控制中心",
  "passportNationalId": "护照/身份证",
  "pending": "待处理",
  "phoneNumber": "电话号码",
  "positionSize": "仓位大小",
  "positionValue": "仓位价值",
  "processing": "处理中...",
  "profileImage": "头像",
  "profileSecurity": "个人资料安全",
  "profileSubtitle": "管理您的账户资料、安全、身份及个人信息。",
  "profileTitle": "个人资料",
  "profileUpdateFailed": "个人资料更新失败。",
  "profileUpdatedSuccessfully": "个人资料更新成功。",
  "read": "已读",
  "rejected": "已拒绝",
  "removeImage": "移除头像",
  "required": "必填",
  "riskAmount": "风险金额",
  "riskPercent": "风险百分比",
  "riskPositionCalculator": "风险与仓位计算器",
  "role": "角色",
  "saveProfile": "保存资料",
  "savingProfile": "资料保存中...",
  "securityLevel": "安全等级",
  "selfieVerification": "自拍验证",
  "sendEmailOtp": "发送邮箱验证码",
  "sendingEmailOtp": "发送中...",
  "serverError": "服务器错误。",
  "sessionActive": "会话有效",
  "sessionExpired": "会话已过期，请重新登录。",
  "subject": "主题",
  "submitKyc": "提交 KYC",
  "submitTicket": "提交工单",
  "submittingKyc": "KYC 提交中...",
  "supportBadge": "客服",
  "supportRequiredFields": "主题和描述为必填项。",
  "telegram": "Telegram 用户名",
  "ticketSubmittedSuccessfully": "工单提交成功。",
  "tools": "工具",
  "totalNotifications": "通知总数",
  "twoFactorStatus": "双重身份验证",
  "uid": "UID",
  "unread": "未读",
  "updateSuccessful": "个人资料更新成功。",
  "uploadBackSide": "上传背面",
  "uploadDocument": "上传文件",
  "uploadFrontSide": "上传正面",
  "uploadIdDocument": "请上传身份证件。",
  "uploadImage": "上传图片",
  "uploadSelfie": "上传自拍照",
  "uploadSelfieRequired": "提交前请上传自拍照。",
  "user": "用户",
  "userId": "用户ID",
  "userProfile": "用户资料",
  "utilityTools": "实用工具",
  "verified": "已验证",
  "verifiedBadge": "已验证",
  "verifiedEmail": "已验证",
  "verifyEmailFirst": "请先验证您的邮箱。",
  "verifyingEmailOtp": "验证中...",
  "walletAddress": "钱包地址",
  "walletOrderTxOptional": "钱包地址、订单编号或交易编号（可选）",
  "writeProfessionalBio": "撰写一段专业的自我介绍。"
}